import { FC } from 'react'
import { Whitepaper as WhitepaperProps } from 'src/api/types'
import { BreadCrumbs as BreadCrumbsProps } from 'src/types'
import BreadCrums from '@/components/Breadcrums'
import Whitepaper from '@/components/Whitepaper'
import WhitepaperInquiry from '@/components/WhitepaperInquiry'

export type Props = {
  whitepaper: WhitepaperProps
  breadcrumbs: BreadCrumbsProps
  toThanks: (title: string) => void
}

const Container: FC<Props> = ({ whitepaper: wp, breadcrumbs, toThanks }) => {
  return (
    <main className="flex flex-col items-center">
      <div className="w-4/5 lg:w-auto lg:min-w-min">
        <BreadCrums items={breadcrumbs} />
        <div className="flex justify-center md:justify-around flex-wrap mt-4 gap-10">
          <div className="lg:w-[480px] xl:w-[600px]">
            <Whitepaper {...wp} />
          </div>
          <div className="border border-primary-800 p-4 lg:border-none lg:p-0 w-full lg:w-[480px] xl:w-[600px]">
            <WhitepaperInquiry title={wp.title} toThanks={toThanks}/>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Container
